<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col xl="5" lg="4" class="fixed-div">
                    <b-row class="full-height" >
                        <b-col md="12" class="align-self-center text-center">
                            <h1><img class="logo" src="../../assets/imgs/domik_white_logo.svg" alt=""></h1>
                        </b-col>
                        <b-col md="12" class="text-center wrapper-social-media-form">
                            <a href="https://www.facebook.com/uniformesmedicosdomik?mibextid=ZbWKwL" target="_blank"><img class="" src="../../assets/imgs/icn_facebook_org.svg" alt=""></a>
                            <a href="https://instagram.com/domikuniformes?igshid=YmMyMTA2M2Y=" target="_blank"><img class="" src="../../assets/imgs/icn_instagram_org.svg" alt=""></a>
                            <a href="https://www.linkedin.com/company/domik-medical-apparel/" target="_blank"><img class="" src="../../assets/imgs/icn_linkedin_org.svg" alt=""></a>
                            <a href="https://domikuniformes.com/" target="_blank"><img class="" src="../../assets/imgs/icn_website_org.svg" alt=""></a>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col offset-xl="5" xl="7"  offset-lg="4" lg="8" class="order-container">
                    <b-container>
                        <b-row>
                            <b-col cols="12" class="mb-3">
                                <h3 class="mb-5">¡Bienvenido! Registra tus datos</h3>
                                <h2 class="text-center mb-4" v-if="dataUser.hospital" :key="dataUser.hospital" v-html="breakBeforeParen(dataUser.hospital)"></h2>
                                <b-alert v-if="empty" :key="empty" show variant="danger">Es obligatorio llenar todos los campos correctamente.</b-alert>
                            </b-col>
                            <b-col style="visibility: hidden; height: 5px;" cols="12" class="mb-3">
                                <single-select
                                    :disabled="true"
                                    v-model="dataUser.hospital"
                                    :options="optionsHospitals"
                                    placeholder=""
                                    :required="true"
                                    :key="optionsHospitals.lenght"
                                    :label="'Selecciona el Hospital al que perteneces'"
                                    class="select-hospitals"
                                    :class="{'required-select':  (empty && (dataUser.hospital=='' || dataUser.hospital==null))}"
                                ></single-select>
                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital==''||dataUser.hospital==null))}">Favor de ingresar datos</span>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <single-select
                                    v-model="dataUser.category"
                                    :options="optionsCategories"
                                    placeholder=""
                                    option-label="name"
                                    :required="true"
                                    :label="'Selecciona tu configuración'"
                                    :class="{'required-select':  (empty && (dataUser.category=='' || dataUser.category==null))}"
                                ></single-select>
                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.area==''||dataUser.area==null))}">Favor de ingresar datos</span>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <single-select
                                    v-model="dataUser.area"
                                    :options="optionsAreas"
                                    :key="optionsAreas.lenght"
                                    placeholder=""
                                    option-label="name"
                                    :required="true"
                                    :label="'Selecciona tu Sub Configuración de Puesto'"
                                    :class="{'required-select':  (empty && (dataUser.area=='' || dataUser.area==null))}"
                                ></single-select>
                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.area==''||dataUser.area==null))}">Favor de ingresar datos</span>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <single-select
                                    v-model="dataUser.jobPosition"
                                    :options="optionsJobPosition"
                                    placeholder=""
                                    :required="true"
                                    :label="'Selecciona tu Puesto'"
                                    :class="{'required-select':  (empty && (dataUser.jobPosition==''||dataUser.jobPosition==null))}"
                                ></single-select>
                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.jobPosition==''||dataUser.jobPosition==null))}">Favor de ingresar datos</span>
                            </b-col> 
                            <!-- <b-col cols="12" class="mb-3 form-floating" v-if="dataUser.area=='Dirección Médica' || dataUser.area=='7 Dirección Médica DAMA' || dataUser.area=='8 Dirección Médica CABALLERO' ">
                                <b-form-input id="input-4" v-model="dataUser.speciality" placeholder="Especialidad" type="text" :class="{'required':  (empty && dataUser.speciality=='')}"></b-form-input>
                                <label for="input-4">Especialidad</label> 
                                <span class="required-label" :class="{'showlabel': (empty && dataUser.speciality=='')}">Favor de ingresar datos</span>
                            </b-col> -->
                            <b-col cols="12" class="mb-3 form-floating">
                                <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number" maxlength = "6" class="form-control" v-model="dataUser.colaborator" @change="checkCollaborators" placeholder="# Colaborador" :class="{'required':  (empty && dataUser.colaborator=='')}" id="input-1">
                                <label for="input-1"># Colaborador</label>
                                <span class="required-label" :class="{'showlabel': (empty && dataUser.colaborator=='')}">Favor de ingresar datos</span>
                                <span class="required-label" :class="{'showlabel': checkIfCollaboratorsExist}" :key="checkIfCollaboratorsExist">El número de colaborar ingresado ya cuenta con una orden realizada</span>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <div class="radioBtn radioBtn-border" :class="{'required':  (empty && dataUser.gender=='')}">
                                    <b-form-radio-group
                                        id="btn-radios-1"
                                        v-model="dataUser.gender"
                                        :options="optionsGender"
                                        button-variant="outline-primary"
                                        size="lg"
                                        name="radio-btn-outline"
                                         :class="{'active': dataUser.gender}"
                                        buttons
                                    ></b-form-radio-group>
                                    <span class="required-label" :class="{'showlabel': (empty && dataUser.gender=='')}">Favor de ingresar datos</span>
                                </div>
                            </b-col>
                            <b v-if="hasClothesType.scrub=='BOT195'">Se solicita al usuario revisar en el manual la guía de tallas específica para el modelo BOT195, a fin de asegurar la selección correcta.</b>
                            <b-col v-if="hasClothesType.scrub" :key="hasClothesType.scrub" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset :class="{'required':  (empty && (dataUser.scrub=='' || dataUser.scrub==null))}">
                                    <legend>Filipina {{hasClothesType.scrub}}</legend>
                                    <label :class="{'show': dataUser.scrub}" for="">Talla de Filipina</label>
                                    <vue-single-select
                                        :key="dataUser.gender+1"
                                        v-model="dataUser.scrub"
                                        :options="setSize(1)"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                    <span class="required-label" :class="{'showlabel': (empty && (dataUser.scrub=='' || dataUser.scrub== null))}">Favor de ingresar datos</span>
                                </fieldset>
                            </b-col>
                            <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 form-floating" v-if="hasClothesType.scrub">
                                <fieldset :class="{'required':  (empty && (dataUser.scrub=='' || dataUser.scrub==null))}">
                                    <legend>Color </legend>
                                    <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.colorScrub" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                </fieldset>
                            </b-col>
                            <!-- <b-col v-if="hasClothesType.scrub" :key="hasClothesType.scrub" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.scrubQty}" class="mb-3 size-container pt-2">
                                <div class="qty-container" :class="{'required':  (empty && dataUser.scrubQty=='')}">
                                    <label for="input-6">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-6"
                                        :min="0"
                                        v-model="dataUser.scrubQty"
                                        disabled
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                                <span class="required-label" :class="{'showlabel': (empty && dataUser.scrubQty=='')}">Favor de ingresar datos</span>
                            </b-col> -->
                            <b-col v-if="hasClothesType.pant" :key="hasClothesType.pant" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset  :class="{'required':  (empty && (dataUser.pants=='' || dataUser.pants==null))}">
                                    <legend>Pantalón {{hasClothesType.pant}}</legend>
                                    <label :class="{'show': dataUser.pants}" for="">Talla de Pantalón</label>
                                    <vue-single-select
                                        :key="dataUser.gender"
                                        v-model="dataUser.pants"
                                        :options="setSize(2)"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                    <span class="required-label" :class="{'showlabel': (empty && (dataUser.pants==''||dataUser.pants==null))}">Favor de ingresar datos</span>
                                </fieldset>
                            </b-col>
                            <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 form-floating" v-if="hasClothesType.pant">
                                <fieldset>
                                    <legend>Color </legend>
                                    <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.colorPants" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                </fieldset>
                            </b-col>
                            <!-- <b-col v-if="hasClothesType.pant" :key="hasClothesType.pant" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.pantsQty}" class="mb-3 size-container pt-2">
                                <div class="qty-container" :class="{'required':  (empty && dataUser.pantsQty=='')}">
                                    <label for="input-7">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-7"
                                        :min="0"
                                        v-model="dataUser.pantsQty"
                                        disabled
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                                <span class="required-label" :class="{'showlabel': (empty && dataUser.pantsQty=='')}">Favor de ingresar datos</span>
                            </b-col> -->
                            <b-row v-for="(item, id) in hasClothesType.coat" :key="id" style="padding: 0!important; margin: 0 !important">
                                <b v-if="item=='BRC965'">Se solicita al usuario revisar en el manual la guía de tallas específica para el modelo BRC965, a fin de asegurar la selección correcta.</b>                            
                                <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                    <fieldset :class="{'required':  (empty && (dataUser.coat[id].size==''||dataUser.coat[id].size==null))}">
                                        <legend>Bata {{item}}</legend>
                                        <label :class="{'show': dataUser.coat[id].size}" for="">Talla de Batas</label>
                                        <div>
                                            <vue-single-select
                                                :key="dataUser.gender"
                                                v-model="dataUser.coat[id].size"
                                                :options="setSizeCoat(item)"
                                                placeholder=""
                                                :required="true"
                                            ></vue-single-select>
                                        </div>
                                        <span class="required-label" :class="{'showlabel': (empty && (dataUser.coat[id].size==''||dataUser.coat[id].size==null))}">Favor de ingresar datos</span>
                                    </fieldset>
                                </b-col>
                                <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 form-floating" v-if="dataUser.coat[id].color">
                                    <fieldset>
                                        <legend>Color </legend>
                                        <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.coat[id].color" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                    </fieldset>
                                </b-col>
                                <!-- <b-col :key="hasClothesType.coat" v-if="hasClothesType.coat" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.coat[id].cantidad}" class="mb-3 size-container pt-2">
                                    <div class="qty-container" :class="{'required':  (empty && dataUser.coat[id].cantidad=='')}">
                                        <label for="input-8">Cantidad</label>
                                        <vue-numeric-input
                                            id="input-8"
                                            :min="0"
                                            disabled
                                            v-model="dataUser.coat[id].cantidad"
                                            className="form-control-qty"
                                            controls-type="updown">
                                        </vue-numeric-input>
                                    </div>
                                    <span class="required-label" :class="{'showlabel': (empty && dataUser.coat[id].cantidad=='')}">Favor de ingresar datos</span>
                                </b-col> -->
                            </b-row>
                            <b-col v-if="hasClothesType.scrubCap" :key="hasClothesType.scrubCap" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset :class="{'required':  (empty && (dataUser.scrubCap==''||dataUser.scrubCap==null))}">
                                    <legend>Chamarras {{hasClothesType.scrubCap}}</legend>
                                    <label :class="{'show': dataUser.scrubCap}" for="">Talla de Chamarras</label>
                                    <vue-single-select
                                        :key="dataUser.gender"
                                        v-model="dataUser.scrubCap"
                                        :options="setSize(3)"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                    <span class="required-label" :class="{'showlabel': (empty && (dataUser.scrubCap==''||dataUser.scrubCap==null))}">Favor de ingresar datos</span>
                                </fieldset>
                            </b-col>
                            <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 pb-1 form-floating" v-if="hasClothesType.scrubCap">
                                    <fieldset>
                                        <legend>Color </legend>
                                        <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.colorScrubCap" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                    </fieldset>
                                </b-col>
                            <!-- <b-col v-if="hasClothesType.scrubCap" :key="hasClothesType.scrubCap" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.scrubCapQty}" class="mb-3 size-container pt-2">
                                <div class="qty-container" :class="{'required':  (empty && dataUser.scrubCapQty=='')}">
                                    <label for="input-9">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-9"
                                        :min="0"
                                        disabled
                                        v-model="dataUser.scrubCapQty"
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                                <span class="required-label" :class="{'showlabel': (empty && dataUser.scrubCapQty=='')}">Favor de ingresar datos</span>
                            </b-col> -->
                            <b-col v-if="hasClothesType.overol" :key="hasClothesType.overol" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset :class="{'required':  (empty && (dataUser.overol==''||dataUser.overol==null))}">
                                    <legend>Overol {{hasClothesType.overol}}</legend>
                                    <label :class="{'show': dataUser.overol}" for="">Talla de Overol</label>
                                    <vue-single-select
                                        :key="dataUser.gender"
                                        v-model="dataUser.overol"
                                        :options="setSize(8)"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                    <span class="required-label" :class="{'showlabel': (empty && (dataUser.overol==''||dataUser.overol==null))}">Favor de ingresar datos</span>
                                </fieldset>
                            </b-col>
                            <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 pb-1 form-floating" v-if="hasClothesType.overol">
                                    <fieldset>
                                        <legend>Color </legend>
                                        <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.coloroverol" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                    </fieldset>
                            </b-col>

                            <b-col v-if="hasClothesType.shoes" :key="hasClothesType.shoes" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset :class="{'required':  (empty && (dataUser.shoes==''||dataUser.shoes==null))}">
                                    <legend>Calzado {{hasClothesType.shoes}}</legend>
                                    <label :class="{'show': dataUser.shoes}" for="">Talla de Calzado</label>
                                    <vue-single-select
                                        :key="dataUser.gender"
                                        v-model="dataUser.shoes"
                                        :options="setSize(5)"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                    <span class="required-label" :class="{'showlabel': (empty && (dataUser.shoes==''||dataUser.shoes==null))}">Favor de ingresar datos</span>
                                </fieldset>
                            </b-col>
                            <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3 pb-1 form-floating" v-if="hasClothesType.shoes">
                                    <fieldset>
                                        <legend>Color </legend>
                                        <b-form-input class="mb-2" id="input-4" disabled v-model="dataUser.colorshoes" placeholder="Color" type="text" style="border: none !important; height: 39px;"></b-form-input>
                                    </fieldset>
                                </b-col>
                            
                            
                            <b-col md="10">
                                <b-button v-on:click="submitOrder">Continuar</b-button>
                            </b-col>
                            <b-col md="12" class="mb-3 mt-5 text-center">
                                <img v-if="dataUser.img" :src="dataUser.img">
                            </b-col>

                        </b-row>
                    </b-container>
                    
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import VueSingleSelect from 'vue-single-select'
    import SingleSelect from '../elements/SingleSelect.vue'
    // import VueNumericInput from 'vue-numeric-input'
    import axios from 'axios'
    import qs from 'qs'

    export default {
        components: {
            VueSingleSelect,
            SingleSelect,
            // VueNumericInput
        },
        updated() {
            this.readFromLocal = 0
        },
        created() {
            var datalist = sessionStorage.getItem('dataUser');
            if (datalist) {
                this.readFromLocal = 1
                this.dataUser = JSON.parse(datalist)
            }
            var token = sessionStorage.getItem('api_token')
            var id_user = sessionStorage.getItem('id_user')

            var user_hospital = JSON.parse(sessionStorage.getItem('user_hospital'))
            var key_hospital
            for (const [key] of Object.entries(user_hospital)) {
                key_hospital= key
            }

            this.dataUser.hospital = this.$R.prop('name', user_hospital[key_hospital]);
            this.dataUser.img = this.$R.prop('image', user_hospital[key_hospital]);

            axios
            .post(
                'https://api-starmedica.domikuniformes.com/orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_catalogs',
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    var listHospitals = [],
                        listComplete = [],
                        listGender = [],
                        listCategories = []
                    Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
                        listHospitals.push(value[0].name)
                        listComplete.push(value[0])
                    })
                    Object.keys(response.data.gender).map((key) => [response.data.gender[key]]).map(function(value) {
                        listGender.push(value[0])
                    })
                    Object.keys(response.data.categories).map((key) => [response.data.categories[key]]).map(function(value) {
                        listCategories.push(value[0])
                    })

                    this.listCollaborators = response.data.collaborators
                    this.optionsHospitals = listHospitals
                    this.optionsHospitalsComplete = listComplete
                    this.optionsGenderAPI = listGender
                    this.optionsCategories = listCategories
                }
            })
            .catch((err) => {
                console.log(err)
            })
                
        },
        data() {
            return {
                dataUser:{ 
                    hospital: '',
                    category: '',
                    img: '',
                    area: '',
                    colaborator: '',
                    name: '',
                    lastname1: '',
                    lastname2: '',
                    speciality: '',
                    jobPosition: '',
                    gender: '',
                    scrub: '',
                    scrubQty: 0,
                    pants: '',
                    pantsQty: 0,
                    overolQty: 0,
                    shoesQty: 0,
                    coat: [{
                        size: '',
                        cantidad: 0,
                        color: ''
                    },{
                        size: '',
                        cantidad: 0,
                        color: ''
                    }],
                    coatModel:'',
                    coatQty: 0,
                    scrubCap: '',
                    scrubCapQty: 0,
                    embroidery: '',
                    embroideryText: '',
                    phone: '',
                    email: '',
                    modelCoat: [],
                    modelScrub: '',
                    modelPants: '',
                    modelOverol: '',
                    modelShoes: '',
                    modelScrubCap: '',
                    colorCoat: [],
                    colorScrub: '',
                    colorPants: '',
                    colorScrubCap: '',
                    coloroverol: '',
                    colorshoes: '',
                },
                listCollaborators: [],
                checkIfCollaboratorsExist: false,
                readFromLocal: 0, 
                optionsCategories: [],
                optionsHospitals: [],
                optionsHospitalsComplete: [],
                optionsGenderAPI: [],
                optionsSizes: ['XXS','XS','S','M','L','XL','2XL','3XL'],
                optionsSizes2: ['XS','S','M','L','XL','2XL','3XL'],
                optionsSizesMenCoat: ['32','34','36','38','40','42','44','46'],
                optionsSizesMen: ['32','34','36','38','40','42','44','46','48','50','52','54','56'],
                optionsGender: [
                    { text: 'Hombre', value: 'Hombre'},
                    { text: 'Mujer', value: 'Mujer'}
                ],
                optionsEmbroidery: [
                    { text: 'Sí', value: 'Sí' },
                    { text: 'No', value: 'No' }
                ],
                empty: false,
                emptySize: true,
                messageColab: ''
            }
        }, 
        methods: {
            breakBeforeParen(value) {
                if (!value) return ''
                return value.replace(/\(/g, '<br>(')
            },
            checkCollaborators() {
                var a = this.listCollaborators.filter((x) =>
                    x=== this.dataUser.colaborator)
                    this.checkIfCollaboratorsExist = a.length > 0 ? true : false
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true;
                }
            },
            submitOrder() {
                this.empty = true
                this.emptySize = true
                if( this.dataUser.hospital &&
                    this.dataUser.area &&
                    this.dataUser.jobPosition &&
                    this.dataUser.gender &&
                    this.dataUser.colaborator &&
                    !this.checkIfCollaboratorsExist) {    

                    if(this.hasClothesType.scrub && (this.dataUser.scrub == '' || this.dataUser.scrub == null )){
                        this.emptySize = false
                    }

                    if(this.hasClothesType.pant && (this.dataUser.pants == '' || this.dataUser.pants == null )){
                        this.emptySize = false
                    }

                    if(this.hasClothesType.scrubCap && (this.dataUser.scrubCap== '' || this.dataUser.scrubCap == null )){
                        this.emptySize = false
                    }

                    if(this.hasClothesType.coat[0] && (this.dataUser.coat[0].size == '' || this.dataUser.coat[0].size == null )){
                        this.emptySize = false
                    }


                    if(this.hasClothesType.coat[1] && (this.dataUser.coat[1].size == '' || this.dataUser.coat[1].size == null )){
                        this.emptySize = false
                    }
                    
                    if(this.emptySize) {
                        this.dataUser.modelScrub = this.hasClothesType.scrub 
                        this.dataUser.modelPants = this.hasClothesType.pant
                        this.dataUser.modelCoat = this.hasClothesType.coat
                        this.dataUser.modelOverol = this.hasClothesType.overol
                        this.dataUser.modelShoes = this.hasClothesType.shoes
                        this.dataUser.modelScrubCap = this.hasClothesType.scrubCap
                        sessionStorage.setItem('dataUser',JSON.stringify(this.dataUser))
                        this.$router.push({ name: 'DetailsOrder', params: { data: this.dataUser}})
                    } else {
                        this.empty = true
                    }
                    window.scrollTo(0,0)
                }
            },
            setColor( catalogfull ){
                this.dataUser.colorScrub = catalogfull.filipina_color
                this.dataUser.colorScrubCap = catalogfull.chamarra_color
                this.dataUser.colorPants = catalogfull.pantalon_color
                this.dataUser.coloroverol = catalogfull.overol_color
                this.dataUser.colorshoes = catalogfull.calzado_color
                this.dataUser.coat[0].color = catalogfull.bata_color
                this.dataUser.coat[1].color = catalogfull.bata_color
            },
            setQtyValue( catalogfull ){
                this.dataUser.scrubQty = catalogfull.filipina_qty
                this.dataUser.scrubCapQty = catalogfull.chamarra_qty
                this.dataUser.pantsQty = catalogfull.pantalon_qty
                this.dataUser.overolQty = catalogfull.overol_qty
                this.dataUser.shoesQty = catalogfull.calzado_qty
                this.dataUser.coat[0].cantidad = catalogfull.bata_qty
                this.dataUser.coat[1].cantidad = catalogfull.bata_qty
            },
            setSizeCoat(name){
                if (this.dataUser.hospital && this.dataUser.area && this.dataUser.gender) {
                    let 
                        gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender)[0].id,
                        catalogfull = this.optionsHospitalsComplete.filter((x) =>
                                    x.name === this.dataUser.hospital)[0].sharedArea.filter((x) =>
                                    x.name === this.dataUser.area.name)[0].catalog,
                        catalog = catalogfull.sharedModel.filter((x) =>
                                    x.gender_id == gender),
                        tempSize = [],
                        arraySize = catalog.filter((x) => x.name == name).map(y => y.sharedSize)[0]
                        Object.keys(arraySize).map((key) => [arraySize[key]]).map(function(value) {
                            tempSize.push(value[0].name)
                        })
                    return tempSize 
                } else {
                    return ''
                }
            },
            setSize(type) {
                if (this.dataUser.hospital && this.dataUser.area && this.dataUser.gender) {
                    let 
                        gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender)[0].id,
                        catalogfull = this.optionsHospitalsComplete.filter((x) =>
                                    x.name === this.dataUser.hospital)[0].sharedArea.filter((x) =>
                                    x.name === this.dataUser.area.name)[0].catalog,
                        catalog = catalogfull.sharedModel.filter((x) =>
                                    x.gender_id == gender),
                        tempSize = [],
                        arraySize = catalog.filter((x) => x.type_id == type).map(y => y.sharedSize)[0]
                        Object.keys(arraySize).map((key) => [arraySize[key]]).map(function(value) {
                            tempSize.push(value[0].name)
                        })
                    return tempSize 
                } else {
                    return ''
                }
            }
        },
        watch: {
            'dataUser.hospital' (){
                if(!this.readFromLocal) {
                    this.dataUser.area = ''
                    this.dataUser.jobPosition = ''
                    this.dataUser.speciality = ''
                    this.dataUser.scrub = ''
                    this.dataUser.pants = ''
                    this.dataUser.coat[0].size = ''
                    this.dataUser.coat[1].size = ''
                    this.dataUser.scrubCap = ''
                    this.dataUser.scrubQty = 0
                    this.dataUser.scrubCapQty = 0
                    this.dataUser.pantsQty = 0
                    this.dataUser.shoesQty = 0
                    this.dataUser.overolQty = 0
                    this.dataUser.coat[0].cantidad = 0
                    this.dataUser.coat[1].cantidad = 0
                }
            },
            'dataUser.area' (){
                if(!this.readFromLocal) {
                    this.dataUser.jobPosition = ''
                    this.dataUser.speciality = ''
                    this.dataUser.scrub = ''
                    this.dataUser.pants = ''
                    this.dataUser.coat[0].size = ''
                    this.dataUser.coat[1].size = ''
                    this.dataUser.scrubCap = ''
                    this.dataUser.scrubQty = 0
                    this.dataUser.scrubCapQty = 0
                    this.dataUser.pantsQty = 0
                    this.dataUser.overolQty = 0
                    this.dataUser.shoesQty = 0
                    this.dataUser.coat[0].cantidad = 0
                    this.dataUser.coat[1].cantidad = 0
                }
            },
            'dataUser.gender' (){
                if(!this.readFromLocal) {
                    this.dataUser.scrub = ''
                    this.dataUser.pants = ''
                    this.dataUser.coat[0].size = ''
                    this.dataUser.coat[1].size = ''
                    this.dataUser.scrubCap = ''
                }
            }
        },
        computed: {
            optionsAreas: function() {
                if (this.dataUser.hospital && this.dataUser.category) {
                    let temp = this.optionsHospitalsComplete.filter((x) =>
                    x.name === this.dataUser.hospital)
                    return temp.map(x => x.sharedArea)[0].filter((z) =>
                    z.category_id === this.dataUser.category.id).map(({ id, name }) => ({ id, name })) 
                } else {
                    return ['']
                }
            },
            optionsJobPosition: function() {
                 if (this.dataUser.hospital && this.dataUser.area) {
                    let temp = this.optionsHospitalsComplete.filter((x) =>
                    x.name === this.dataUser.hospital).map(x => x.sharedArea)[0].filter((x) =>
                    x.name === this.dataUser.area.name)
                    return temp.map(x => x.ownPosition)[0].map(y => y.name) 
                } else {
                    return ['']
                }
            },
            optionsModelsCoat:  function() {
                if (this.dataUser.hospital && this.dataUser.area && this.dataUser.gender) {
                    let     gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender).map(y => y.id),
                            catalog = this.optionsHospitalsComplete.filter((x) =>
                                        x.name === this.dataUser.hospital)[0].sharedArea.filter((x) =>
                                        x.name === this.dataUser.area.name)[0].catalog.sharedModel.filter((x) =>
                                        x.gender_id == gender).filter((x) => x.type_id === '3'),
                            listComplete = []
                                        
                            Object.keys(catalog).map((key) => [catalog[key]]).map(function(value) {
                                listComplete.push(value[0].name)
                            })
                    return listComplete 
                } else {
                    return ['']
                }
            },
            hasClothesType: function(){
                if (this.dataUser.hospital && this.dataUser.area && this.dataUser.gender) {
                    let elements = {
                        scrub: '',
                        pant: '',
                        coat: '',
                        shoes: '',
                        overol: ''
                    },
                        gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender)[0].id,
                        catalogfull = this.optionsHospitalsComplete.filter((x) =>
                                    x.name === this.dataUser.hospital)[0].sharedArea.filter((x) =>
                                    x.name === this.dataUser.area.name)[0].catalog,
                        catalog = catalogfull.sharedModel.filter((x) =>
                                    x.gender_id == gender)
                    
                    this.setQtyValue(catalogfull)
                    this.setColor(catalogfull)

                
                    elements.overol = catalog.filter((x) => x.type_id === '8').map(y => y.name).toString()
                    elements.shoes = catalog.filter((x) => x.type_id === '5').map(y => y.name).toString()
                    elements.scrub = catalog.filter((x) => x.type_id === '1').map(y => y.name).toString()
                    elements.pant = catalog.filter((x) => x.type_id === '2').map(y => y.name).toString()
                    elements.coat = catalog.filter((x) => x.type_id === '4').map(y => y.name)
                    elements.scrubCap  = catalog.filter((x) => x.type_id === '3').map(y => y.name).toString()
                    return elements 
                } else {
                    return ''
                }
            }
        }
    }
</script>

<style scoped>
.order-container{
    padding: 70px 12% 70px 7%;
}
.full-height{
    position: relative;
    height: 100vh;
}
.fixed-div{
    position: fixed;
    background: #5A6FBE;
    background-image: url('../../assets/imgs/img_photo.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    max-height: 100vh;
}
h2{
    font-weight: bold;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 14px; 
}
.text-namehospital{
    text-transform: uppercase;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
    width: 100%;
}
.btn-group{
    width: 100%;
}
legend {
    color: rgba(89, 101, 177, 1);
    float: none;
    width: fit-content;
    padding: 0;
    margin-bottom: 0.5rem;
    margin-left: 1rem;
    font-size: 15px;
    line-height: inherit;
    margin-bottom: 0;
}
fieldset{
    border: 1px solid #5965B1;
    border-radius: 5px;
    position: relative;
}
fieldset label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
fieldset label.show{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container{
    position: relative;
}

.size-container label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.size-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container.coat-container label{
    left: calc(2rem - 2px);
    color: rgba(89, 101, 177, 0.4);
}
.size-container.coat-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.qty-container{
    position: relative;
    width: 100%;
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    padding: 0.4rem 0.5rem;
    height: 100%;
}
.qty-container.required{
    border-color: #D85067 !important;
}
.radioBtn-border{
    border: 1px solid rgba(89, 101, 177, 1);
}
.embroid-container{
    border-radius: 5px;
    width: 100%;
    display: -webkit-flex;
    display: flex;
}
.embroid-container label{
    margin-right: 20px;
    margin-left: 1.1rem;
    margin-top: 0.6rem;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.embroid-container.show label{
    color: rgba(89, 101, 177,1) !important;
}
.embroid-container .radioBtn{
    width: inherit;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.showlabel.required-label{
    display: block;
}

.wrapper-social-media-form{
    position: absolute;
    bottom: 10%;
}

.wrapper-social-media-form a{
    margin: 12px;
}
@media (max-width: 1600px) {
    .order-container{
        padding: 70px 10% 70px 6%;
    }
    h3{
        font-size: 20px;
    }
    p{
        font-size: 12px; 
    }
    .note{
        font-size: 11px;
    }
    legend {
        font-size: 12px;
    }
    .logo{
        width: 70%;
    }
    .wrapper-social-media-form{
        margin-top: 50px;
    }
    .wrapper-social-media-form a{
        margin: 10px;
    }
    .wrapper-social-media-form img{
        width: 40px;
    }
    .qty-container{
        height: 45px;
    }
    .size-container label{
        bottom: 25%;
        font-size: 14px;
    }
    .size-container.coat-container label{
        left: 2rem;
        font-size: 14px;
    }
    .embroid-container label,
    fieldset label{
        font-size: 14px;
    }
}
@media (max-width: 991px) {
    .fixed-div{
        position: relative;
        background: #5A6FBE;
        padding: 10% 0;
        width: 100%;
        overflow-x: hidden;
    }
    .full-height{
        height: fit-content;
    }
    .wrapper-social-media-form{
        position: relative;
        bottom: 10%;
    }
}

@media (max-width: 768px) {

    h2{
        font-size: 20px;
    }
    .order-container{
        padding: 50px 5% 50px 5%;
    }
    .wrapper-social-media-form{
        margin-top: 70px;
    }
}
</style>

